// Facets, section grids & blogs for the World Tour Packages page.
const M = (f) => `/assets/media/${f}`;

const IMG = {
  europeCity: M("013-images-unsplash-com-photo-1502602898657-3e91760cbb34.jpg"),
  europeCity2: M("010-images-unsplash-com-photo-1499856871958-5b9627545d1a.jpg"),
  alps: M("026-images-unsplash-com-photo-1541849546-216549ae216d.jpg"),
  santorini: M("020-images-unsplash-com-photo-1530841377377-3ff06c0ca713.jpg"),
  santorini2: M("021-images-unsplash-com-photo-1530841377377-3ff06c0ca713.jpg"),
  aurora: M("011-images-unsplash-com-photo-1500382017468-9049fed747ef.jpg"),
  thailand: M("015-images-unsplash-com-photo-1506665531195-3566af2b4dfa.jpg"),
  thailand2: M("016-images-unsplash-com-photo-1506665531195-3566af2b4dfa.jpg"),
  singapore: M("019-images-unsplash-com-photo-1525625293386-3f8f99389edd.jpg"),
  singapore2: M("033-images-unsplash-com-photo-1565967511849-76a60a516170.jpg"),
  beach: M("024-images-unsplash-com-photo-1537996194471-e657df975ab4.jpg"),
  beach2: M("025-images-unsplash-com-photo-1537996194471-e657df975ab4.jpg"),
  dubai: M("049-images-unsplash-com-photo-1749849934727-bc57c0bd9dd2.jpg"),
  dubai2: M("050-images-unsplash-com-photo-1749849934727-bc57c0bd9dd2.jpg"),
  nepal: M("040-images-unsplash-com-photo-1605640840605-14ac1855827b.jpg"),
};

export const WORLD_REGION_TABS = [
  { label: "All of World", count: 329 },
  { label: "Europe", count: 129 },
  { label: "South East Asia", count: 60 },
  { label: "Africa & Middle East", count: 12 },
  { label: "Mauritius", count: 9 },
  { label: "Bhutan", count: 8 },
  { label: "Nepal", count: 7 },
];

export const WORLD_PRICE_PRESETS = [
  { label: "₹ 1.2L - ₹ 2.5L", min: 120000, max: 250000 },
  { label: "₹ 2.5L - ₹ 3.8L", min: 250000, max: 380000 },
  { label: "₹ 3.8L - ₹ 5.1L", min: 380000, max: 510000 },
  { label: "₹ 5.1L above", min: 510000, max: 10000000 },
];

export const WORLD_DURATION_PRESETS = [
  { label: "3 - 9 Days", min: 3, max: 9 },
  { label: "9 - 15 Days", min: 9, max: 15 },
  { label: "15 - 21 Days", min: 15, max: 21 },
  { label: "21 - 27 Days", min: 21, max: 27 },
];

export const WORLD_DEPARTURE_CITIES = [
  { label: "Joining / Leaving", count: 139 },
  { label: "Washington D.C.", count: 2 },
  { label: "Rio De Janeiro", count: 2 },
  { label: "Kathmandu", count: 2 },
  { label: "Denpasar (Bali)", count: 2 },
  { label: "Chicago", count: 2 },
  { label: "Calgary", count: 3 },
  { label: "New York", count: 4 },
  { label: "Bangalore", count: 16 },
  { label: "Coimbatore", count: 40 },
  { label: "Nagpur", count: 57 },
  { label: "Bengaluru", count: 71 },
  { label: "Cochin", count: 72 },
  { label: "Goa", count: 74 },
  { label: "Chennai", count: 78 },
  { label: "Indore", count: 80 },
  { label: "Kolkata", count: 84 },
  { label: "Ahmedabad", count: 87 },
  { label: "New Delhi", count: 89 },
  { label: "Hyderabad", count: 90 },
  { label: "Mumbai", count: 142 },
];

export const WORLD_PACKAGE_TYPES = [
  { label: "All", count: 329 },
  { label: "Customized Holidays", count: 166 },
  { label: "Group Tour", count: 162 },
  { label: "Inbound", count: 1 },
];

export const WORLD_SPECIALITY = [
  { label: "Customized Holidays", count: 143 },
  { label: "Family", count: 128 },
  { label: "Women's Special", count: 20 },
  { label: "Fixed Date Holiday", count: 16 },
  { label: "Seniors' Special", count: 13 },
  { label: "Post Tour Holidays", count: 5 },
  { label: "Honeymoon Special", count: 1 },
  { label: "Inbound", count: 1 },
];

export const WORLD_COUNTRIES = [
  { label: "Switzerland", count: 27 },
  { label: "United States", count: 26 },
  { label: "Austria", count: 23 },
  { label: "France", count: 23 },
  { label: "Germany", count: 21 },
  { label: "Italy", count: 21 },
  { label: "China", count: 17 },
  { label: "Thailand", count: 17 },
  { label: "Australia", count: 16 },
  { label: "Singapore", count: 16 },
];

export const WORLD_CITIES = [
  { label: "Lucerne", count: 132 },
  { label: "Paris", count: 128 },
  { label: "Zurich", count: 117 },
  { label: "Innsbruck", count: 111 },
  { label: "Wattens", count: 109 },
  { label: "Schaffhausen", count: 108 },
  { label: "Vaduz", count: 107 },
  { label: "Engelberg", count: 106 },
  { label: "Mount Titlis", count: 105 },
  { label: "Interlaken", count: 70 },
];

export const WORLD_TOURS_FROM = [
  { city: "Washington D.C.", count: 2 },
  { city: "Rio De Janeiro", count: 2 },
  { city: "Kathmandu", count: 2 },
  { city: "Denpasar (Bali)", count: 2 },
  { city: "Chicago", count: 2 },
  { city: "Calgary", count: 3 },
  { city: "New York", count: 4 },
  { city: "Bangalore", count: 16 },
  { city: "Coimbatore", count: 40 },
  { city: "Nagpur", count: 57 },
  { city: "Bengaluru", count: 71 },
  { city: "Cochin", count: 72 },
  { city: "Goa", count: 74 },
  { city: "Chennai", count: 78 },
  { city: "Indore", count: 80 },
  { city: "Kolkata", count: 84 },
  { city: "Ahmedabad", count: 87 },
  { city: "New Delhi", count: 89 },
  { city: "Hyderabad", count: 90 },
  { city: "Mumbai", count: 142 },
];

export const WORLD_BY_REGION = {
  Europe: [
    { name: "Europe Tour Packages", tours: 129, image: IMG.europeCity },
    { name: "Central And Eastern Europe Tour Packages", tours: 14, image: IMG.europeCity2 },
    { name: "Northern Lights Tour Packages", tours: 3, image: IMG.aurora },
    { name: "Midnight Sun Tour Packages", tours: 6, image: IMG.aurora },
    { name: "Scandinavia Tour Packages", tours: 15, image: IMG.alps },
  ],
  Australia: [
    { name: "Australia Tour Packages", tours: 22, image: IMG.beach },
    { name: "New Zealand Tour Packages", tours: 12, image: IMG.alps },
    { name: "Fiji Tour Packages", tours: 4, image: IMG.beach2 },
  ],
  America: [
    { name: "USA Tour Packages", tours: 26, image: IMG.europeCity2 },
    { name: "Canada Tour Packages", tours: 18, image: IMG.alps },
    { name: "South America Tour Packages", tours: 9, image: IMG.beach },
  ],
  "Africa & Middle East": [
    { name: "Dubai Tour Packages", tours: 24, image: IMG.dubai },
    { name: "Mauritius Tour Packages", tours: 9, image: IMG.beach },
    { name: "South Africa Tour Packages", tours: 8, image: IMG.santorini },
    { name: "Egypt Tour Packages", tours: 6, image: IMG.dubai2 },
  ],
  Asia: [
    { name: "Thailand Tour Packages", tours: 17, image: IMG.thailand },
    { name: "Singapore Tour Packages", tours: 16, image: IMG.singapore },
    { name: "Bali Tour Packages", tours: 14, image: IMG.beach2 },
    { name: "Japan Tour Packages", tours: 10, image: IMG.alps },
  ],
};

export const WORLD_BY_COUNTRY = [
  { name: "Thailand", tours: 17, image: IMG.thailand },
  { name: "Mauritius", tours: 9, image: IMG.beach },
  { name: "Singapore", tours: 16, image: IMG.singapore },
  { name: "Italy", tours: 21, image: IMG.europeCity },
  { name: "Japan", tours: 10, image: IMG.alps },
  { name: "Greece", tours: 8, image: IMG.santorini },
];

export const WORLD_BY_CITY = [
  { name: "Paris", tours: 22, image: IMG.europeCity },
  { name: "Lucerne", tours: 18, image: IMG.alps },
  { name: "Dubai", tours: 24, image: IMG.dubai },
  { name: "Bangkok", tours: 15, image: IMG.thailand2 },
  { name: "Singapore", tours: 16, image: IMG.singapore2 },
  { name: "Bali", tours: 14, image: IMG.beach2 },
];

export const WORLD_BY_SEASON = {
  "March to June": [
    { name: "Europe", tours: 129, image: IMG.europeCity },
    { name: "Switzerland", tours: 27, image: IMG.alps },
    { name: "Dubai", tours: 24, image: IMG.dubai },
    { name: "Thailand", tours: 17, image: IMG.thailand },
    { name: "Singapore", tours: 16, image: IMG.singapore },
    { name: "Bali", tours: 14, image: IMG.beach2 },
  ],
  "July to October": [
    { name: "Scandinavia", tours: 15, image: IMG.aurora },
    { name: "Northern Lights", tours: 3, image: IMG.aurora },
    { name: "Greece", tours: 8, image: IMG.santorini },
    { name: "Japan", tours: 10, image: IMG.alps },
    { name: "Nepal", tours: 7, image: IMG.nepal },
    { name: "Bhutan", tours: 8, image: IMG.nepal },
  ],
  "November to February": [
    { name: "Mauritius", tours: 9, image: IMG.beach },
    { name: "Australia", tours: 22, image: IMG.beach2 },
    { name: "New Zealand", tours: 12, image: IMG.alps },
    { name: "Dubai", tours: 24, image: IMG.dubai },
    { name: "USA", tours: 26, image: IMG.europeCity2 },
    { name: "Sri Lanka", tours: 12, image: IMG.beach },
  ],
};

export const WORLD_BY_DURATION = [
  { label: "Less than 6 days", min: 0, max: 6, tours: 62, image: IMG.dubai },
  { label: "7 to 10 days", min: 7, max: 10, tours: 148, image: IMG.thailand },
  { label: "11 to 15 days", min: 11, max: 15, tours: 84, image: IMG.europeCity },
  { label: "More than 16 days", min: 16, max: 99, tours: 35, image: IMG.aurora },
];

export const WORLD_BY_INTEREST_TABS = ["Honeymoon Special", "Women's Special", "Seniors' Special"];

export const WORLD_BLOGS = [
  { title: "Great Wall Of China: Beyond Imagination", image: IMG.alps },
  { title: "Europe, Again And Again!", image: IMG.europeCity },
  { title: "The Silicon Valley Of The East", image: IMG.singapore },
  { title: "The Charm Of Sicily", image: IMG.santorini },
  { title: "They Beat The French", image: IMG.beach },
];

export const WORLD_REVIEWS = [
  { rating: 5, tag: "Family", title: "Best of Bali", text: "Tour guide Suved was very good and the best. Thank u for the best experience", author: "Yukta", date: "Jul, 2026", managers: "Suved Desai", image: IMG.beach2 },
  { rating: 5, tag: "Family", title: "Best of Bali", text: "The tour was crazy, and the main thing I want to tell you is our tour guide Suved desai he is not just a tour manager he is brother…", author: "Atharva", date: "Jul, 2026", managers: "Suved Desai", image: IMG.beach },
  { rating: 5, tag: "Family", title: "Singapore Thailand Malaysia", text: "Our Thailand, Singapore, and Malaysia tour with Royal Tours was truly a wonderful and memorable experience. Everything was well planned…", author: "Dinesh", date: "Jul, 2026", managers: "Prasad Chavan", image: IMG.singapore },
];

export const WORLD_INTRO =
  "From the snow-dusted peaks of the Alps to the neon skylines of the Far East, from midnight-sun fjords to golden desert dunes — the world is an open invitation. Royal Tours crafts seamless international holidays across the globe with visa assistance, air-inclusive options and expert tour managers, so all you carry is your sense of wonder.";
